"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ligatureReference = {
    "\u0626\u0627": {
        "isolated": "\uFBEA",
        "final": "\uFBEB"
    },
    "\u0626\u06D5": {
        "isolated": "\uFBEC",
        "final": "\uFBED"
    },
    "\u0626\u0648": {
        "isolated": "\uFBEE",
        "final": "\uFBEF"
    },
    "\u0626\u06C7": {
        "isolated": "\uFBF0",
        "final": "\uFBF1"
    },
    "\u0626\u06C6": {
        "isolated": "\uFBF2",
        "final": "\uFBF3"
    },
    "\u0626\u06C8": {
        "isolated": "\uFBF4",
        "final": "\uFBF5"
    },
    "\u0626\u06D0": {
        "isolated": "\uFBF6",
        "final": "\uFBF7",
        "initial": "\uFBF8"
    },
    "\u0626\u0649": {
        "uighur_kirghiz": {
            "isolated": "\uFBF9",
            "final": "\uFBFA",
            "initial": "\uFBFB"
        },
        "isolated": "\uFC03",
        "final": "\uFC68"
    },
    "\u0626\u062C": {
        "isolated": "\uFC00",
        "initial": "\uFC97"
    },
    "\u0626\u062D": {
        "isolated": "\uFC01",
        "initial": "\uFC98"
    },
    "\u0626\u0645": {
        "isolated": "\uFC02",
        "final": "\uFC66",
        "initial": "\uFC9A",
        "medial": "\uFCDF"
    },
    "\u0626\u064A": {
        "isolated": "\uFC04",
        "final": "\uFC69"
    },
    "\u0628\u062C": {
        "isolated": "\uFC05",
        "initial": "\uFC9C"
    },
    "\u0628\u062D": {
        "isolated": "\uFC06",
        "initial": "\uFC9D"
    },
    "\u0628\u062E": {
        "isolated": "\uFC07",
        "initial": "\uFC9E"
    },
    "\u0628\u0645": {
        "isolated": "\uFC08",
        "final": "\uFC6C",
        "initial": "\uFC9F",
        "medial": "\uFCE1"
    },
    "\u0628\u0649": {
        "isolated": "\uFC09",
        "final": "\uFC6E"
    },
    "\u0628\u064A": {
        "isolated": "\uFC0A",
        "final": "\uFC6F"
    },
    "\u062A\u062C": {
        "isolated": "\uFC0B",
        "initial": "\uFCA1"
    },
    "\u062A\u062D": {
        "isolated": "\uFC0C",
        "initial": "\uFCA2"
    },
    "\u062A\u062E": {
        "isolated": "\uFC0D",
        "initial": "\uFCA3"
    },
    "\u062A\u0645": {
        "isolated": "\uFC0E",
        "final": "\uFC72",
        "initial": "\uFCA4",
        "medial": "\uFCE3"
    },
    "\u062A\u0649": {
        "isolated": "\uFC0F",
        "final": "\uFC74"
    },
    "\u062A\u064A": {
        "isolated": "\uFC10",
        "final": "\uFC75"
    },
    "\u062B\u062C": {
        "isolated": "\uFC11"
    },
    "\u062B\u0645": {
        "isolated": "\uFC12",
        "final": "\uFC78",
        "initial": "\uFCA6",
        "medial": "\uFCE5"
    },
    "\u062B\u0649": {
        "isolated": "\uFC13",
        "final": "\uFC7A"
    },
    "\u062B\u0648": {
        "isolated": "\uFC14"
    },
    "\u062C\u062D": {
        "isolated": "\uFC15",
        "initial": "\uFCA7"
    },
    "\u062C\u0645": {
        "isolated": "\uFC16",
        "initial": "\uFCA8"
    },
    "\u062D\u062C": {
        "isolated": "\uFC17",
        "initial": "\uFCA9"
    },
    "\u062D\u0645": {
        "isolated": "\uFC18",
        "initial": "\uFCAA"
    },
    "\u062E\u062C": {
        "isolated": "\uFC19",
        "initial": "\uFCAB"
    },
    "\u062E\u062D": {
        "isolated": "\uFC1A"
    },
    "\u062E\u0645": {
        "isolated": "\uFC1B",
        "initial": "\uFCAC"
    },
    "\u0633\u062C": {
        "isolated": "\uFC1C",
        "initial": "\uFCAD",
        "medial": "\uFD34"
    },
    "\u0633\u062D": {
        "isolated": "\uFC1D",
        "initial": "\uFCAE",
        "medial": "\uFD35"
    },
    "\u0633\u062E": {
        "isolated": "\uFC1E",
        "initial": "\uFCAF",
        "medial": "\uFD36"
    },
    "\u0633\u0645": {
        "isolated": "\uFC1F",
        "initial": "\uFCB0",
        "medial": "\uFCE7"
    },
    "\u0635\u062D": {
        "isolated": "\uFC20",
        "initial": "\uFCB1"
    },
    "\u0635\u0645": {
        "isolated": "\uFC21",
        "initial": "\uFCB3"
    },
    "\u0636\u062C": {
        "isolated": "\uFC22",
        "initial": "\uFCB4"
    },
    "\u0636\u062D": {
        "isolated": "\uFC23",
        "initial": "\uFCB5"
    },
    "\u0636\u062E": {
        "isolated": "\uFC24",
        "initial": "\uFCB6"
    },
    "\u0636\u0645": {
        "isolated": "\uFC25",
        "initial": "\uFCB7"
    },
    "\u0637\u062D": {
        "isolated": "\uFC26",
        "initial": "\uFCB8"
    },
    "\u0637\u0645": {
        "isolated": "\uFC27",
        "initial": "\uFD33",
        "medial": "\uFD3A"
    },
    "\u0638\u0645": {
        "isolated": "\uFC28",
        "initial": "\uFCB9",
        "medial": "\uFD3B"
    },
    "\u0639\u062C": {
        "isolated": "\uFC29",
        "initial": "\uFCBA"
    },
    "\u0639\u0645": {
        "isolated": "\uFC2A",
        "initial": "\uFCBB"
    },
    "\u063A\u062C": {
        "isolated": "\uFC2B",
        "initial": "\uFCBC"
    },
    "\u063A\u0645": {
        "isolated": "\uFC2C",
        "initial": "\uFCBD"
    },
    "\u0641\u062C": {
        "isolated": "\uFC2D",
        "initial": "\uFCBE"
    },
    "\u0641\u062D": {
        "isolated": "\uFC2E",
        "initial": "\uFCBF"
    },
    "\u0641\u062E": {
        "isolated": "\uFC2F",
        "initial": "\uFCC0"
    },
    "\u0641\u0645": {
        "isolated": "\uFC30",
        "initial": "\uFCC1"
    },
    "\u0641\u0649": {
        "isolated": "\uFC31",
        "final": "\uFC7C"
    },
    "\u0641\u064A": {
        "isolated": "\uFC32",
        "final": "\uFC7D"
    },
    "\u0642\u062D": {
        "isolated": "\uFC33",
        "initial": "\uFCC2"
    },
    "\u0642\u0645": {
        "isolated": "\uFC34",
        "initial": "\uFCC3"
    },
    "\u0642\u0649": {
        "isolated": "\uFC35",
        "final": "\uFC7E"
    },
    "\u0642\u064A": {
        "isolated": "\uFC36",
        "final": "\uFC7F"
    },
    "\u0643\u0627": {
        "isolated": "\uFC37",
        "final": "\uFC80"
    },
    "\u0643\u062C": {
        "isolated": "\uFC38",
        "initial": "\uFCC4"
    },
    "\u0643\u062D": {
        "isolated": "\uFC39",
        "initial": "\uFCC5"
    },
    "\u0643\u062E": {
        "isolated": "\uFC3A",
        "initial": "\uFCC6"
    },
    "\u0643\u0644": {
        "isolated": "\uFC3B",
        "final": "\uFC81",
        "initial": "\uFCC7",
        "medial": "\uFCEB"
    },
    "\u0643\u0645": {
        "isolated": "\uFC3C",
        "final": "\uFC82",
        "initial": "\uFCC8",
        "medial": "\uFCEC"
    },
    "\u0643\u0649": {
        "isolated": "\uFC3D",
        "final": "\uFC83"
    },
    "\u0643\u064A": {
        "isolated": "\uFC3E",
        "final": "\uFC84"
    },
    "\u0644\u062C": {
        "isolated": "\uFC3F",
        "initial": "\uFCC9"
    },
    "\u0644\u062D": {
        "isolated": "\uFC40",
        "initial": "\uFCCA"
    },
    "\u0644\u062E": {
        "isolated": "\uFC41",
        "initial": "\uFCCB"
    },
    "\u0644\u0645": {
        "isolated": "\uFC42",
        "final": "\uFC85",
        "initial": "\uFCCC",
        "medial": "\uFCED"
    },
    "\u0644\u0649": {
        "isolated": "\uFC43",
        "final": "\uFC86"
    },
    "\u0644\u064A": {
        "isolated": "\uFC44",
        "final": "\uFC87"
    },
    "\u0645\u062C": {
        "isolated": "\uFC45",
        "initial": "\uFCCE"
    },
    "\u0645\u062D": {
        "isolated": "\uFC46",
        "initial": "\uFCCF"
    },
    "\u0645\u062E": {
        "isolated": "\uFC47",
        "initial": "\uFCD0"
    },
    "\u0645\u0645": {
        "isolated": "\uFC48",
        "final": "\uFC89",
        "initial": "\uFCD1"
    },
    "\u0645\u0649": {
        "isolated": "\uFC49"
    },
    "\u0645\u064A": {
        "isolated": "\uFC4A"
    },
    "\u0646\u062C": {
        "isolated": "\uFC4B",
        "initial": "\uFCD2"
    },
    "\u0646\u062D": {
        "isolated": "\uFC4C",
        "initial": "\uFCD3"
    },
    "\u0646\u062E": {
        "isolated": "\uFC4D",
        "initial": "\uFCD4"
    },
    "\u0646\u0645": {
        "isolated": "\uFC4E",
        "final": "\uFC8C",
        "initial": "\uFCD5",
        "medial": "\uFCEE"
    },
    "\u0646\u0649": {
        "isolated": "\uFC4F",
        "final": "\uFC8E"
    },
    "\u0646\u064A": {
        "isolated": "\uFC50",
        "final": "\uFC8F"
    },
    "\u0647\u062C": {
        "isolated": "\uFC51",
        "initial": "\uFCD7"
    },
    "\u0647\u0645": {
        "isolated": "\uFC52",
        "initial": "\uFCD8"
    },
    "\u0647\u0649": {
        "isolated": "\uFC53"
    },
    "\u0647\u064A": {
        "isolated": "\uFC54"
    },
    "\u064A\u062C": {
        "isolated": "\uFC55",
        "initial": "\uFCDA"
    },
    "\u064A\u062D": {
        "isolated": "\uFC56",
        "initial": "\uFCDB"
    },
    "\u064A\u062E": {
        "isolated": "\uFC57",
        "initial": "\uFCDC"
    },
    "\u064A\u0645": {
        "isolated": "\uFC58",
        "final": "\uFC93",
        "initial": "\uFCDD",
        "medial": "\uFCF0"
    },
    "\u064A\u0649": {
        "isolated": "\uFC59",
        "final": "\uFC95"
    },
    "\u064A\u064A": {
        "isolated": "\uFC5A",
        "final": "\uFC96"
    },
    "\u0630\u0670": {
        "isolated": "\uFC5B"
    },
    "\u0631\u0670": {
        "isolated": "\uFC5C"
    },
    "\u0649\u0670": {
        "isolated": "\uFC5D",
        "final": "\uFC90"
    },
    "\u064C\u0651": {
        "isolated": "\uFC5E"
    },
    "\u064D\u0651": {
        "isolated": "\uFC5F"
    },
    "\u064E\u0651": {
        "isolated": "\uFC60"
    },
    "\u064F\u0651": {
        "isolated": "\uFC61"
    },
    "\u0650\u0651": {
        "isolated": "\uFC62"
    },
    "\u0651\u0670": {
        "isolated": "\uFC63"
    },
    "\u0626\u0631": {
        "final": "\uFC64"
    },
    "\u0626\u0632": {
        "final": "\uFC65"
    },
    "\u0626\u0646": {
        "final": "\uFC67"
    },
    "\u0628\u0631": {
        "final": "\uFC6A"
    },
    "\u0628\u0632": {
        "final": "\uFC6B"
    },
    "\u0628\u0646": {
        "final": "\uFC6D"
    },
    "\u062A\u0631": {
        "final": "\uFC70"
    },
    "\u062A\u0632": {
        "final": "\uFC71"
    },
    "\u062A\u0646": {
        "final": "\uFC73"
    },
    "\u062B\u0631": {
        "final": "\uFC76"
    },
    "\u062B\u0632": {
        "final": "\uFC77"
    },
    "\u062B\u0646": {
        "final": "\uFC79"
    },
    "\u062B\u064A": {
        "final": "\uFC7B"
    },
    "\u0645\u0627": {
        "final": "\uFC88"
    },
    "\u0646\u0631": {
        "final": "\uFC8A"
    },
    "\u0646\u0632": {
        "final": "\uFC8B"
    },
    "\u0646\u0646": {
        "final": "\uFC8D"
    },
    "\u064A\u0631": {
        "final": "\uFC91"
    },
    "\u064A\u0632": {
        "final": "\uFC92"
    },
    "\u064A\u0646": {
        "final": "\uFC94"
    },
    "\u0626\u062E": {
        "initial": "\uFC99"
    },
    "\u0626\u0647": {
        "initial": "\uFC9B",
        "medial": "\uFCE0"
    },
    "\u0628\u0647": {
        "initial": "\uFCA0",
        "medial": "\uFCE2"
    },
    "\u062A\u0647": {
        "initial": "\uFCA5",
        "medial": "\uFCE4"
    },
    "\u0635\u062E": {
        "initial": "\uFCB2"
    },
    "\u0644\u0647": {
        "initial": "\uFCCD"
    },
    "\u0646\u0647": {
        "initial": "\uFCD6",
        "medial": "\uFCEF"
    },
    "\u0647\u0670": {
        "initial": "\uFCD9"
    },
    "\u064A\u0647": {
        "initial": "\uFCDE",
        "medial": "\uFCF1"
    },
    "\u062B\u0647": {
        "medial": "\uFCE6"
    },
    "\u0633\u0647": {
        "medial": "\uFCE8",
        "initial": "\uFD31"
    },
    "\u0634\u0645": {
        "medial": "\uFCE9",
        "isolated": "\uFD0C",
        "final": "\uFD28",
        "initial": "\uFD30"
    },
    "\u0634\u0647": {
        "medial": "\uFCEA",
        "initial": "\uFD32"
    },
    "\u0640\u064E\u0651": {
        "medial": "\uFCF2"
    },
    "\u0640\u064F\u0651": {
        "medial": "\uFCF3"
    },
    "\u0640\u0650\u0651": {
        "medial": "\uFCF4"
    },
    "\u0637\u0649": {
        "isolated": "\uFCF5",
        "final": "\uFD11"
    },
    "\u0637\u064A": {
        "isolated": "\uFCF6",
        "final": "\uFD12"
    },
    "\u0639\u0649": {
        "isolated": "\uFCF7",
        "final": "\uFD13"
    },
    "\u0639\u064A": {
        "isolated": "\uFCF8",
        "final": "\uFD14"
    },
    "\u063A\u0649": {
        "isolated": "\uFCF9",
        "final": "\uFD15"
    },
    "\u063A\u064A": {
        "isolated": "\uFCFA",
        "final": "\uFD16"
    },
    "\u0633\u0649": {
        "isolated": "\uFCFB"
    },
    "\u0633\u064A": {
        "isolated": "\uFCFC",
        "final": "\uFD18"
    },
    "\u0634\u0649": {
        "isolated": "\uFCFD",
        "final": "\uFD19"
    },
    "\u0634\u064A": {
        "isolated": "\uFCFE",
        "final": "\uFD1A"
    },
    "\u062D\u0649": {
        "isolated": "\uFCFF",
        "final": "\uFD1B"
    },
    "\u062D\u064A": {
        "isolated": "\uFD00",
        "final": "\uFD1C"
    },
    "\u062C\u0649": {
        "isolated": "\uFD01",
        "final": "\uFD1D"
    },
    "\u062C\u064A": {
        "isolated": "\uFD02",
        "final": "\uFD1E"
    },
    "\u062E\u0649": {
        "isolated": "\uFD03",
        "final": "\uFD1F"
    },
    "\u062E\u064A": {
        "isolated": "\uFD04",
        "final": "\uFD20"
    },
    "\u0635\u0649": {
        "isolated": "\uFD05",
        "final": "\uFD21"
    },
    "\u0635\u064A": {
        "isolated": "\uFD06",
        "final": "\uFD22"
    },
    "\u0636\u0649": {
        "isolated": "\uFD07",
        "final": "\uFD23"
    },
    "\u0636\u064A": {
        "isolated": "\uFD08",
        "final": "\uFD24"
    },
    "\u0634\u062C": {
        "isolated": "\uFD09",
        "final": "\uFD25",
        "initial": "\uFD2D",
        "medial": "\uFD37"
    },
    "\u0634\u062D": {
        "isolated": "\uFD0A",
        "final": "\uFD26",
        "initial": "\uFD2E",
        "medial": "\uFD38"
    },
    "\u0634\u062E": {
        "isolated": "\uFD0B",
        "final": "\uFD27",
        "initial": "\uFD2F",
        "medial": "\uFD39"
    },
    "\u0634\u0631": {
        "isolated": "\uFD0D",
        "final": "\uFD29"
    },
    "\u0633\u0631": {
        "isolated": "\uFD0E",
        "final": "\uFD2A"
    },
    "\u0635\u0631": {
        "isolated": "\uFD0F",
        "final": "\uFD2B"
    },
    "\u0636\u0631": {
        "isolated": "\uFD10",
        "final": "\uFD2C"
    },
    "\u0633\u0639": {
        "final": "\uFD17"
    },
    "\u062A\u062C\u0645": {
        "initial": "\uFD50"
    },
    "\u062A\u062D\u062C": {
        "final": "\uFD51",
        "initial": "\uFD52"
    },
    "\u062A\u062D\u0645": {
        "initial": "\uFD53"
    },
    "\u062A\u062E\u0645": {
        "initial": "\uFD54"
    },
    "\u062A\u0645\u062C": {
        "initial": "\uFD55"
    },
    "\u062A\u0645\u062D": {
        "initial": "\uFD56"
    },
    "\u062A\u0645\u062E": {
        "initial": "\uFD57"
    },
    "\u062C\u0645\u062D": {
        "final": "\uFD58",
        "initial": "\uFD59"
    },
    "\u062D\u0645\u064A": {
        "final": "\uFD5A"
    },
    "\u062D\u0645\u0649": {
        "final": "\uFD5B"
    },
    "\u0633\u062D\u062C": {
        "initial": "\uFD5C"
    },
    "\u0633\u062C\u062D": {
        "initial": "\uFD5D"
    },
    "\u0633\u062C\u0649": {
        "final": "\uFD5E"
    },
    "\u0633\u0645\u062D": {
        "final": "\uFD5F",
        "initial": "\uFD60"
    },
    "\u0633\u0645\u062C": {
        "initial": "\uFD61"
    },
    "\u0633\u0645\u0645": {
        "final": "\uFD62",
        "initial": "\uFD63"
    },
    "\u0635\u062D\u062D": {
        "final": "\uFD64",
        "initial": "\uFD65"
    },
    "\u0635\u0645\u0645": {
        "final": "\uFD66",
        "initial": "\uFDC5"
    },
    "\u0634\u062D\u0645": {
        "final": "\uFD67",
        "initial": "\uFD68"
    },
    "\u0634\u062C\u064A": {
        "final": "\uFD69"
    },
    "\u0634\u0645\u062E": {
        "final": "\uFD6A",
        "initial": "\uFD6B"
    },
    "\u0634\u0645\u0645": {
        "final": "\uFD6C",
        "initial": "\uFD6D"
    },
    "\u0636\u062D\u0649": {
        "final": "\uFD6E"
    },
    "\u0636\u062E\u0645": {
        "final": "\uFD6F",
        "initial": "\uFD70"
    },
    "\u0636\u0645\u062D": {
        "final": "\uFD71"
    },
    "\u0637\u0645\u062D": {
        "initial": "\uFD72"
    },
    "\u0637\u0645\u0645": {
        "initial": "\uFD73"
    },
    "\u0637\u0645\u064A": {
        "final": "\uFD74"
    },
    "\u0639\u062C\u0645": {
        "final": "\uFD75",
        "initial": "\uFDC4"
    },
    "\u0639\u0645\u0645": {
        "final": "\uFD76",
        "initial": "\uFD77"
    },
    "\u0639\u0645\u0649": {
        "final": "\uFD78"
    },
    "\u063A\u0645\u0645": {
        "final": "\uFD79"
    },
    "\u063A\u0645\u064A": {
        "final": "\uFD7A"
    },
    "\u063A\u0645\u0649": {
        "final": "\uFD7B"
    },
    "\u0641\u062E\u0645": {
        "final": "\uFD7C",
        "initial": "\uFD7D"
    },
    "\u0642\u0645\u062D": {
        "final": "\uFD7E",
        "initial": "\uFDB4"
    },
    "\u0642\u0645\u0645": {
        "final": "\uFD7F"
    },
    "\u0644\u062D\u0645": {
        "final": "\uFD80",
        "initial": "\uFDB5"
    },
    "\u0644\u062D\u064A": {
        "final": "\uFD81"
    },
    "\u0644\u062D\u0649": {
        "final": "\uFD82"
    },
    "\u0644\u062C\u062C": {
        "initial": "\uFD83",
        "final": "\uFD84"
    },
    "\u0644\u062E\u0645": {
        "final": "\uFD85",
        "initial": "\uFD86"
    },
    "\u0644\u0645\u062D": {
        "final": "\uFD87",
        "initial": "\uFD88"
    },
    "\u0645\u062D\u062C": {
        "initial": "\uFD89"
    },
    "\u0645\u062D\u0645": {
        "initial": "\uFD8A"
    },
    "\u0645\u062D\u064A": {
        "final": "\uFD8B"
    },
    "\u0645\u062C\u062D": {
        "initial": "\uFD8C"
    },
    "\u0645\u062C\u0645": {
        "initial": "\uFD8D"
    },
    "\u0645\u062E\u062C": {
        "initial": "\uFD8E"
    },
    "\u0645\u062E\u0645": {
        "initial": "\uFD8F"
    },
    "\u0645\u062C\u062E": {
        "initial": "\uFD92"
    },
    "\u0647\u0645\u062C": {
        "initial": "\uFD93"
    },
    "\u0647\u0645\u0645": {
        "initial": "\uFD94"
    },
    "\u0646\u062D\u0645": {
        "initial": "\uFD95"
    },
    "\u0646\u062D\u0649": {
        "final": "\uFD96"
    },
    "\u0646\u062C\u0645": {
        "final": "\uFD97",
        "initial": "\uFD98"
    },
    "\u0646\u062C\u0649": {
        "final": "\uFD99"
    },
    "\u0646\u0645\u064A": {
        "final": "\uFD9A"
    },
    "\u0646\u0645\u0649": {
        "final": "\uFD9B"
    },
    "\u064A\u0645\u0645": {
        "final": "\uFD9C",
        "initial": "\uFD9D"
    },
    "\u0628\u062E\u064A": {
        "final": "\uFD9E"
    },
    "\u062A\u062C\u064A": {
        "final": "\uFD9F"
    },
    "\u062A\u062C\u0649": {
        "final": "\uFDA0"
    },
    "\u062A\u062E\u064A": {
        "final": "\uFDA1"
    },
    "\u062A\u062E\u0649": {
        "final": "\uFDA2"
    },
    "\u062A\u0645\u064A": {
        "final": "\uFDA3"
    },
    "\u062A\u0645\u0649": {
        "final": "\uFDA4"
    },
    "\u062C\u0645\u064A": {
        "final": "\uFDA5"
    },
    "\u062C\u062D\u0649": {
        "final": "\uFDA6"
    },
    "\u062C\u0645\u0649": {
        "final": "\uFDA7"
    },
    "\u0633\u062E\u0649": {
        "final": "\uFDA8"
    },
    "\u0635\u062D\u064A": {
        "final": "\uFDA9"
    },
    "\u0634\u062D\u064A": {
        "final": "\uFDAA"
    },
    "\u0636\u062D\u064A": {
        "final": "\uFDAB"
    },
    "\u0644\u062C\u064A": {
        "final": "\uFDAC"
    },
    "\u0644\u0645\u064A": {
        "final": "\uFDAD"
    },
    "\u064A\u062D\u064A": {
        "final": "\uFDAE"
    },
    "\u064A\u062C\u064A": {
        "final": "\uFDAF"
    },
    "\u064A\u0645\u064A": {
        "final": "\uFDB0"
    },
    "\u0645\u0645\u064A": {
        "final": "\uFDB1"
    },
    "\u0642\u0645\u064A": {
        "final": "\uFDB2"
    },
    "\u0646\u062D\u064A": {
        "final": "\uFDB3"
    },
    "\u0639\u0645\u064A": {
        "final": "\uFDB6"
    },
    "\u0643\u0645\u064A": {
        "final": "\uFDB7"
    },
    "\u0646\u062C\u062D": {
        "initial": "\uFDB8",
        "final": "\uFDBD"
    },
    "\u0645\u062E\u064A": {
        "final": "\uFDB9"
    },
    "\u0644\u062C\u0645": {
        "initial": "\uFDBA",
        "final": "\uFDBC"
    },
    "\u0643\u0645\u0645": {
        "final": "\uFDBB",
        "initial": "\uFDC3"
    },
    "\u062C\u062D\u064A": {
        "final": "\uFDBE"
    },
    "\u062D\u062C\u064A": {
        "final": "\uFDBF"
    },
    "\u0645\u062C\u064A": {
        "final": "\uFDC0"
    },
    "\u0641\u0645\u064A": {
        "final": "\uFDC1"
    },
    "\u0628\u062D\u064A": {
        "final": "\uFDC2"
    },
    "\u0633\u062E\u064A": {
        "final": "\uFDC6"
    },
    "\u0646\u062C\u064A": {
        "final": "\uFDC7"
    },
    "\u0644\u0622": {
        "isolated": "\uFEF5",
        "final": "\uFEF6"
    },
    "\u0644\u0623": {
        "isolated": "\uFEF7",
        "final": "\uFEF8"
    },
    "\u0644\u0625": {
        "isolated": "\uFEF9",
        "final": "\uFEFA"
    },
    "\u0644\u0627": {
        "isolated": "\uFEFB",
        "final": "\uFEFC"
    },
    "words": {
        "\u0635\u0644\u06D2": "\uFDF0",
        "\u0642\u0644\u06D2": "\uFDF1",
        "\u0627\u0644\u0644\u0647": "\uFDF2",
        "\u0627\u0643\u0628\u0631": "\uFDF3",
        "\u0645\u062D\u0645\u062F": "\uFDF4",
        "\u0635\u0644\u0639\u0645": "\uFDF5",
        "\u0631\u0633\u0648\u0644": "\uFDF6",
        "\u0639\u0644\u064A\u0647": "\uFDF7",
        "\u0648\u0633\u0644\u0645": "\uFDF8",
        "\u0635\u0644\u0649": "\uFDF9",
        "\u0635\u0644\u0649\u0627\u0644\u0644\u0647\u0639\u0644\u064A\u0647\u0648\u0633\u0644\u0645": "\uFDFA",
        "\u062C\u0644\u062C\u0644\u0627\u0644\u0647": "\uFDFB",
        "\u0631\u06CC\u0627\u0644": "\uFDFC"
    }
};
exports.default = ligatureReference;
